// SPDX-License-Identifier: AGPL-3.0-or-later

import {ColorPickerField} from '@app/features/ui/components/form/ColorPickerField';
import myProfileTabStyles from '@app/features/user/components/modals/tabs/MyProfileTab.module.css';
import styles from '@app/features/user/components/modals/tabs/my_profile_tab/AccentColorPicker.module.css';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface AccentColorPickerProps {
	value: number;
	onChange: (value: number) => void;
	disabled?: boolean;
	errorMessage?: string;
}
export const AccentColorPicker = observer(({value, onChange, disabled, errorMessage}: AccentColorPickerProps) => {
	const {t} = useLingui();
	return (
		<div>
			<ColorPickerField
				label={t`Accent Color`}
				description={t`Customizes the border and banner color on your profile`}
				descriptionClassName={myProfileTabStyles.inputFooter}
				value={value}
				onChange={onChange}
				disabled={disabled}
				defaultValue={0x4641d9}
			/>
			{errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
		</div>
	);
});
